import { intercept } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { IEBPExpenseType } from 'src/Interfaces/TestInterface';
import { UserStore } from 'src/Stores/User/UserStore';
import DataService from '../../../../Services/Data';
import DataTable from '../../../DataTable';


interface IList {
    headers: any[];
    rows: any[];
}

@inject('stores')
@observer
class AdminExpenseTypes extends React.Component {
    public props: any;
    public adminStore: any;
    public expenseTypesDisposer: any; 
    public expenseTypes: IEBPExpenseType[] = [];
    public expenseTypeList: IList;
    public dataService: any = new DataService();
    private UserStore: UserStore;
    
    private tableHeaders: any[] = [
        { content: 'Name', 'class': 'align-left' },
        { content: 'Is Rental', 'class': 'align-left' },
    ];


    public state = {
        expenseTypes: this.expenseTypes,
        formattedExpenseTypeData: this.expenseTypeList,
    };

    constructor(props: any) {
        super(props);
        this.UserStore = this.props.stores.UserStore;
        this.adminStore = this.props.stores.AdminStore;
    }

    public componentDidMount() {
        this.createDisposers();
        this.adminStore.getExpenseTypes();
    }

    public componentWillUnmount() {
        this.clearDisposers();
    }

    public createDisposers() {
        this.expenseTypesDisposer = intercept(this.adminStore, 'expenseTypes', (change: any) => {
            let data = change.newValue;

            data = this.dataService.sort(data, { name: 'asc' });

            this.setState({
                expenseTypes: data
            });

            this.formatDataTable();

            return change;
        });
    }

    public clearDisposers() {
        this.expenseTypesDisposer();
    }

    public renderExpenseTypeName(expenseType: IEBPExpenseType) {
        return(
            <Link to={'/admin/expenseTypes/' + expenseType.id}>{expenseType.name}</Link>
        );
    }

    public formatDataTable() {
        const formattedData: any[] = [];
        this.state.expenseTypes.map((expenseType: IEBPExpenseType, index: number) => {
            const row = [
                {
                    'class': 'align-left',
                    content: this.renderExpenseTypeName.bind(this, expenseType),
                    sortItem: expenseType.name,
                    type: 'render'
                },
                {
                    'class': 'align-left',
                    content: expenseType.isRental === true ? 'Yes' : 'No'
                }
            ];
            formattedData.push(row);
        });

        this.setState({
            formattedExpenseTypeData: {
                headers: this.tableHeaders,
                rows: formattedData
            }
        });
    }

    public render() {
        return(
            <div>
                <Row className="header">
                    <Col md="6">
                        <h1 className="float-left">EBP Items</h1>
                    </Col>
                    {
                        this.UserStore.hasPermission('Permissions.Admin.Inventory.Create') &&                        
                        <Col md="6">
                            <Link to="/admin/expenseTypes/new">
                                <Button color="primary" className="float-right">
                                    Add New EBP Item
                                </Button>
                            </Link>
                        </Col>
                    }
                </Row>
                <Row>
                    <Col xs="12">
                        <DataTable list={this.state.formattedExpenseTypeData} />
                    </Col>
                </Row>
            </div>
        );
    }

}

export default AdminExpenseTypes;


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/ExpenseTypes/AdminExpenseTypes.tsx